export default "__VITE_ASSET__yDhugIHo__"